import gql from 'graphql-tag';
import CartListFragment from '@/queries/fragments/cartItems.gql.js';

export default gql`
    mutation setPaymentMethodOnCart($cartId: String!, $paymentMethod: PaymentMethodInput!) {
        setPaymentMethodOnCart(input: { cart_id: $cartId, payment_method: $paymentMethod }) {
            cart {
                id
                ...CartListFragment
            }
        }
    }
    ${CartListFragment}
`;
